import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import { BannerPcImage, BannerSpImage, MultiCreatorLpLink } from '../../molecules/multi_creator/MultiCreatorBanner';
import './topPagemultiCreatorBanner.module.scss';

export const TopPageMultiCreatorBanner = observer(({ className }) => {
  const { isDesktop } = useViewportState();
  return isDesktop ? <TopPageMultiCreatorBannerPc className={className} /> : <TopPageMultiCreatorBannerSp />;
});

const TopPageBannerDescription = () => (
  <>
    <div styleName="header">
      <div styleName="br-pc">さらに本格的なアウトプットとサポートで</div>
      キャリアチェンジを目指すなら
    </div>
    <div styleName="description">
      SHElikes MULTI CREATOR COURSE Designerは、 1on1キャリアコーチングを元に自分らしいキャリアの実現をサポートする、
      <span styleName="red">短期集中型の特別コース</span>です。
      少人数のコミュニティで、仲間と切磋琢磨しながらキャリアチェンジを目指します。
    </div>
  </>
);

export const TopPageMultiCreatorBannerSp = () => {
  return (
    <div styleName="multi-creator-banner-wrapper">
      <div styleName="multi-creator-banner-content">
        <div styleName="content">
          <BannerPcImage />
          <TopPageBannerDescription />
          <div styleName="multi-creator-lp-link">
            <MultiCreatorLpLink text="特設ページはこちら" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const TopPageMultiCreatorBannerPc = ({ className }) => {
  return (
    <div styleName={classNames('multi-creator-banner-wrapper')} className={className}>
      <div styleName="multi-creator-banner-content">
        <BannerSpImage />
        <div styleName="content">
          <TopPageBannerDescription />
          <MultiCreatorLpLink text="特設ページはこちら" />
        </div>
      </div>
    </div>
  );
};
